import axios from "axios";

// const baseURL = "https://pitaya-server.herokuapp.com/";
const baseURL = "https://pitaya-pay-serverjs-production.up.railway.app/";
const baseURLdev = "http://localhost:5500/";

const baseURLDjango = "https://pitaya-django-pay.up.railway.app/";
const baseURLdevDjango = "http://127.0.0.1:8080/";

export const createClient = axios.create({
	baseURL: process.env.NODE_ENV !== "production" ? baseURLdev : baseURL,
	headers: {
		"Content-Type": "application/json"
	}
});
export const djangoApi = axios.create({
	baseURL: process.env.NODE_ENV !== "production" ? baseURLdevDjango : baseURLDjango,
});
